import { session } from '@/services/session';

const VIEWER_BANNER_DISMISSAL_KEY_PREFIX = 'hydra-viewer-banner-dismissed';

export function getViewerBannerDismissalKey(activeSessionId: number): string {
  return `${VIEWER_BANNER_DISMISSAL_KEY_PREFIX}:${activeSessionId}`;
}

export function isViewerBannerDismissed(activeSessionId: number): boolean {
  try {
    return session.get(getViewerBannerDismissalKey(activeSessionId)) === true;
  } catch {
    return false;
  }
}

export function dismissViewerBanner(activeSessionId: number): void {
  try {
    session.set(getViewerBannerDismissalKey(activeSessionId), true);
  } catch {
    // Session storage is best-effort; the in-memory component state still dismisses the banner.
  }
}
